import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../_services/api/_api.service';
import { MenuItem } from '../../_models/menu';
import { AuthService } from 'src/app/_services/auth.service';

@Component({
    selector: 'app-sidebar-cmp',
    templateUrl: './sidebar.component.html'
})

export class SidebarComponent implements OnInit {
    isActive = false;
    showMenu = '';

    menuItems: MenuItem[] = [];

    constructor(
        private _api: ApiService,
        private _auth: AuthService
    ) { }

    ngOnInit() {
        // this._api.account().getMenu().subscribe(res => {
        //     this.menuItems = res;
        // });
        this._auth.getRoles().then(roles =>{
            this.menuItems = this.getMenu(roles);

        });
    }


    getMenu(roles: string[]): MenuItem[]{
        let items : MenuItem[] = [];

        const isAdmin = roles.some(r => r == 'ADMIN' || r == 'SUPERADMIN');

        items.push({
            icon: 'fa-home',
            route: '/dashboard/home',
            title: '',
            children: [
                {name: 'Dashboard', route: '/dashboard/home'}
            ]
        });

        if(isAdmin){
            items.push({
                title: 'CLIENTI',
                icon: 'fa-users',
                route: '/dashboard/customer/list',
                children: [
                    {name: 'Lista clienti', route: '/dashboard/customer/list'},
                    {name: 'Nuovo cliente', route: '/dashboard/customer/detail'},
                ]
            });

            items.push({
                title: 'DESTINAZIONI',
                icon: 'fa-map-marker',
                route: '/dashboard/destination/list',
                children: [
                    {name: 'Lista destinazioni', route: '/dashboard/destination/list'},
                    {name: 'Nuovo destinazione', route: '/dashboard/destination/detail'},
                ]
            });

            items.push({
                title: 'ARTICOLI',
                icon: 'fa-th-large',
                route: '/dashboard/article/list',
                children: [
                    {name: 'Lista articoli', route: '/dashboard/article/list'},
                    {name: 'Nuovo articolo', route: '/dashboard/article/detail'},
                ]
            });

            items.push({
                title: 'MOVIMENTI',
                icon: 'fa-cubes',
                route: '/dashboard/stockmovement/list',
                children: [
                    {name: 'Lista movimenti', route: '/dashboard/stockmovement/list'},
                    {name: 'Nuovo movimento', route: '/dashboard/stockmovement/detail'},
                ]
            });

            items.push({
                title: 'NOLEGGI',
                icon: 'fa-file',
                route: '/dashboard/doc/list',
                children: [
                    {name: 'Lista noleggi', route: '/dashboard/doc/list'},
                    {name: 'Nuovo noleggio', route: '/dashboard/doc/detail'},
                ]
            });

            items.push({
                title: 'CALENDARIO',
                icon: 'fa-calendar',
                route: '/dashboard/calendar/list',
                children: [
                    {name: 'Lista articoli', route: '/dashboard/calendar/list'},
                ]
            });

            items.push({
                title: 'IMPOSTAZIONI',
                icon: 'fa-gear',
                route: '/dashboard/settings/departments',
                children: [
                    {name: 'Reparti', route: '/dashboard/settings/departments'},
                ]
            });


        }


        return items;
    }

    eventCalled() {
        this.isActive = !this.isActive;
    }

    addExpandClass(element: any) {
        if (element === this.showMenu) {
            this.showMenu = '0';
        } else {
            this.showMenu = element;
        }
    }
}
